const preventLink = (e) => {
  e.preventDefault();
  e.stopPropagation();
};

export default preventLink;
